// Initialize the Cesium Viewer
function initViewer (controller, element, { accessToken, timeline, shouldAnimate }) {
  // Set the Cesium Ion access token
  Cesium.Ion.defaultAccessToken = accessToken

  // Set default camera extent to Australia
  const extent = Cesium.Rectangle.fromDegrees(110.3761922, -10.00000, 159.2433797, -45.500000)
  Cesium.Camera.DEFAULT_VIEW_RECTANGLE = extent
  Cesium.Camera.DEFAULT_VIEW_FACTOR = 0

  // Create the Cesium Viewer
  const viewer = new Cesium.Viewer(element, {
    shouldAnimate, // Start/stop the timeline
    timeline, // Show hide the timeline
    animation: shouldAnimate, // Show hide the animation controls
    fullscreenElement: element
  })

  // Define the disconnect behavior
  const controllerDisconnect = controller.disconnect.bind(controller)
  Object.assign(controller, {
    disconnect () {
      // Destroy the Viewer
      viewer.destroy()

      // Disconnect the Controller
      controllerDisconnect()
    }
  })

  return viewer
}

// Replace the Cesium Image Logo with a cleaner text version
function beautifyCredit (viewer, element) {
  viewer.scene.postRender.addEventListener((_scene, _time) => {
    element.querySelectorAll('.cesium-credit-logoContainer a').forEach(a => {
      a.innerHTML = 'Imagery: Cesium ION. '
    })
  })
}

export const withLiveCesiumMap = (controller, options) => {
  const element = controller.element
  const viewer = initViewer(controller, element, { ...options, shouldAnimate: true, timeline: true })

  // Clean up the Credits
  beautifyCredit(viewer, element)

  return viewer
}

export const withStaticCesiumMap = (controller, options) => {
  const element = controller.element
  const viewer = initViewer(controller, element, { ...options, shouldAnimate: false, timeline: false })

  // Clean up the Credits
  beautifyCredit(viewer, element)

  return viewer
}
